var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Inspection50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M36,4H26c0,1.1-0.9,2-2,2s-2-0.9-2-2H12C9.8,4,8,5.8,8,8v32c0,2.2,1.8,4,4,4h24c2.2,0,4-1.8,4-4V8C40,5.8,38.2,4,36,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M36,41H12c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1h24c0.6,0,1,0.4,1,1v32C37,40.6,36.6,41,36,41z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#90A4AE",
    d: "M26,4c0,1.1-0.9,2-2,2s-2-0.9-2-2h-7v4c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V4H26z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#90A4AE",
    d: "M24,0c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S26.2,0,24,0z M24,6c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S25.1,6,24,6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M30.6 18.6L21.6 27.6 17.4 23.3 14.9 25.8 21.7 32.5 33.1 21.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Inspection50);
export default __webpack_public_path__ + "static/media/icons8-inspection-50.daa353da30bb394f0e3ec67c3635e05d.svg";
export { ForwardRef as ReactComponent };